export default __webpack_public_path__ + "static/trademark-roi-calculator-a5b2e052ef5f4dfb77500d9ddd9b16ed.png";